import Cookies from 'js-cookie'

/** SSO / Platform 单点登录预留：与后端约定后在 request 层或此处统一读写票据（参见 utils/ssoPlaceholder.js）。 */

function getToken(TokenKey) {
    return Cookies.get(TokenKey)
}

function setToken(TokenKey, token) {
    return Cookies.set(TokenKey, token)
}

function removeToken(TokenKey) {
    return Cookies.remove(TokenKey)
}
export { getToken, setToken, removeToken }


// WEBPACK FOOTER //
// ./src/assets/js/auth.js